import { useSalesLeadsStore } from '../stores/salesLeads.store'

export function useSalesLeads() {
  const leads = useSalesLeadsStore((state) => state.leads)
  const meta = useSalesLeadsStore((state) => state.meta)
  const isLoading = useSalesLeadsStore((state) => state.isLoading)
  const error = useSalesLeadsStore((state) => state.error)

  const fetchLeads = useSalesLeadsStore((state) => state.fetchLeads)
  const clearError = useSalesLeadsStore((state) => state.clearError)
  const updateLeadStatus = useSalesLeadsStore((state) => state.updateLeadStatus)
  return {
    leads,
    meta,
    isLoading,
    error,
    fetchLeads,
    clearError,
    updateLeadStatus,
  }
}
